<template>
    <div class="w-full h-full">
        <FormModal v-if="openUploadModal" @cancel="openUploadModal = false" :valid="uploadCSV != undefined"
            @confirm="uploadTransactions()" title="Update end user tiers" subtitle="Upload user tiers to the system"
            submitButtonText="Update user">

            <input id="rewardImgUpload" type="file" @change="uploadFile" ref="fileInput" accept=".csv">
            <!-- <p class="text-sm">Download transaction template</p> -->


        </FormModal>
        <Header title="Update user tiers" icon="Upload" />
        <Breadcrumbs text1="end-users" :link1='`/end-users`' text2="uploads" :link2='`/end-users/uploads`'>
        </Breadcrumbs>
        <WhiteBox class="" title="Uploads History" subText="">
            <template v-slot:buttons>
                <CustomButton small text="Download template" icon="Download" type="default"
                    @click="downloadCSV()" />
                <CustomButton small text="Upload" icon="Upload" type="action" @click="openUploadModal = true" />
            </template>
            <template v-slot:content>
                <EasyDataTable :table-min-height="0" :headers="headersTable1" :items="fileuploads" :loading="loading"
                    v-model:server-options="serverOptions" :server-items-length="serverItemsLength" :hide-footer="true"
                    :no-hover="true">
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                        <div class="flex justify-center py-4">
                            <div
                                class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                <p class="text-sm mr-2">No results</p>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                </svg>
                            </div>
                        </div>
                    </template>
                    <template #header-action="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>

                    <template #item-action="historicData">
                        <div class="flex justify-end items-center py-1 gap-1">
                            <CustomButton v-if="historicData.fileStatus == 'COMPLETED'" small text="Export cashback"
                                icon="FileDown" type="navigate" @click="download(historicData.id)" />
                        </div>
                    </template>
                    <template #item-createdOn="fileData">
                        <div style="font-size:11px;">
                            {{ niceDateTime(fileData.createdOn) }}
                        </div>
                    </template>
                </EasyDataTable>
            </template>
        </WhiteBox>
    </div>
</template>

<script setup>
</script>

<script>
import { DateTime } from 'luxon';
import Header from "@/components/Header.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import FormModal from '@/components/modals/FormModal.vue';
import Breadcrumbs from '@/components/navbars/Breadcrumbs.vue';

export default {
    name: "view-payouts",
    components: {
        Header,
        WhiteBox,
        CustomButton,
        FormModal,
        Breadcrumbs

    },
    props: {
    },

    data() {
        return {
            openUploadModal: false,
            fileuploads: [],
            serverOptions: {
                page: 1,
                rowsPerPage: 25,
            },
            uploadCSV: undefined,
            serverItemsLength: undefined,
            showErrorModal: false,
            showSuccessModal: false,
            showFormModal: false,
            loading: true,
            headersTable1: [
                { text: "Id", value: "id" },
                { text: "File name", value: "fileName" },
                { text: "Created On", value: "createdOn" },
                { text: "Status", value: "fileStatus" },
            ],
            apiKeys: [

            ],
        }
    },
    created() {
        this.getFileUploads(0, 25)

    },
    methods: {

        downloadCSV() {
            // Define the data
            const headers = ['END_USER_ID', 'CUSTOMER_TIER_ID', 'ACTION'];
            const rows = [
                ['user-1234', 'tier-1234', 'ADD / REMOVE']
            ];

            // Convert to CSV format
            const csvContent = [headers, ...rows]
                .map(row => row.map(value => `"${value}"`).join(','))
                .join('\n');

            // Create blob and trigger download
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('download', 'user_tiers.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },

        uploadFile: function () {
            // const file = event.target.files[0];
            this.uploadCSV = event.target.files[0]


        },

        niceDateTime(dateObject) {
            return DateTime.fromMillis(dateObject).toLocaleString(DateTime.DATETIME_MED)
        },

        niceDateTimeForSubheader(dateObject) {
            return DateTime.fromMillis(dateObject).toFormat('MMMM yyyy')
        },

        async uploadTransactions() {
            const formData = new FormData();
            const api = localStorage.getItem('apiType');

            formData.append('multipartFile', this.uploadCSV);

            try {
                const token = localStorage.getItem('token')
                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/customer-tier/csv/user/tier-upload`, {
                    method: "POST",
                    body: formData,
                    headers: {
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.openUploadModal = false
                    this.getFileUploads(0, 25)
                }

            } catch (error) {
                return;
            }
        },

        async getFileUploads(page, size) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/customer-tier/csv/user/tier-upload?page=${page}&size=${size}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.fileuploads = object.content
                    this.serverItemsLength = object.totalElements
                    this.loading = false
                }

            } catch (error) {
                return;
            }

        },


    },
    computed: {

    },
    mounted() {
        document.title = "Dashboard | Payouts";
    },
    watch: {
        serverOptions: {
            deep: true,
            handler(val) {
                this.getHistoricPayouts(val.page - 1, val.rowsPerPage)
            }
        }
    }
}
</script>